import React, { FC, useCallback, useEffect, useState } from 'react';
import { TeamID } from '../../../scripts/models/common';
import { TeamModel } from '../../../scripts/models/models';
import TeamIcon from '../teamIcon/TeamIcon';
import './TeamSelector.scss';

type DisplayMode = "Vertical" | "Horizontal" | "Vertical Compact"
type TriggerMethod = "Click" | "Hover"

interface IProps {
    teams?: TeamModel[],
    currentTeam?: TeamID,
    setter: React.Dispatch<React.SetStateAction<TeamID | undefined>>,
    triggerMethod?: TriggerMethod,
    displayMode?: DisplayMode
}

const TeamSelector: FC<IProps> = (props) => {
    const { teams, currentTeam, setter, triggerMethod = "Click", displayMode = "Vertical" } = props

    const [clickedTeam, setClickedTeam] = useState<TeamID>();
    const [hoveredTeam, setHoveredTeam] = useState<TeamID>()

    // Should clicking the value again unset it?
    const enableUnsetOnClick = (triggerMethod === "Hover");

    const toggleTeam = useCallback((teamId: TeamID) => {
        if (teamId === clickedTeam && enableUnsetOnClick) {
            setClickedTeam(undefined)
        } else {
            setClickedTeam(teamId)
        }
    }, [clickedTeam, enableUnsetOnClick])

    useEffect(() => {
        let selectedTeam = clickedTeam;
        if (triggerMethod === "Hover" && hoveredTeam !== undefined) {
            selectedTeam = hoveredTeam;
        }
        setter(selectedTeam)
    }, [clickedTeam, hoveredTeam, triggerMethod, setter])

    if (!teams) {
        return <></>
    }

    return (
        <div className={`TeamChooser serif ${displayMode}`}>
            {
                teams.map((team, index) => {
                    const onClick = () => { toggleTeam(team.id) }
                    const onMouseEnter = () => { setHoveredTeam(team.id) }
                    const onMouseLeave = () => { setHoveredTeam(undefined) }
                    const selected = currentTeam === team.id;
                    var classList = "TeamChooser-Row bodyText"
                    if (selected) classList += " selected"
                    // Data is borked, nickname is the location instead of the other part
                    const shortName = team.name.substr(team.locationName.length + 1)
                    //const shortName = team.name.includes(team.nickname) ? team.name.substr(team.nickname.length + 1) : team.name

                    return (
                        <button key={index} className={classList} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                            <TeamIcon emoji={team.emoji} color={team.primaryColor} shape="Small Circle" />
                            <div className="TeamName" style={(team.name) ? { opacity: 1 } : { opacity: 0 }}>
                                {shortName}</div>
                        </button>
                    )
                })
            }
        </div>)
}

export default TeamSelector;